import { useMemo, useState } from "react";
import {
  computeRestaurantMetrics,
  DEFAULT_RESTAURANT_FILTERS,
  type RestaurantFilters,
  type RestaurantMetrics,
} from "../utils/restaurantMetrics";

export interface UseRestaurantAnalyticsData {
  filters: RestaurantFilters;
  // eslint-disable-next-line no-unused-vars
  setFilter: <K extends keyof RestaurantFilters>(key: K, value: RestaurantFilters[K]) => void;
  resetFilters: () => void;
  isFiltered: boolean;
  metrics: RestaurantMetrics;
}

export function useRestaurantAnalyticsData(): UseRestaurantAnalyticsData {
  const [filters, setFilters] = useState<RestaurantFilters>(DEFAULT_RESTAURANT_FILTERS);

  const setFilter = <K extends keyof RestaurantFilters>(key: K, value: RestaurantFilters[K]) => {
    setFilters(current => ({ ...current, [key]: value }));
  };

  const resetFilters = () => setFilters(DEFAULT_RESTAURANT_FILTERS);

  const isFiltered = (Object.keys(DEFAULT_RESTAURANT_FILTERS) as Array<keyof RestaurantFilters>).some(
    key => filters[key] !== DEFAULT_RESTAURANT_FILTERS[key],
  );

  const metrics = useMemo(() => computeRestaurantMetrics(filters), [filters]);

  return { filters, setFilter, resetFilters, isFiltered, metrics };
}
